<template>
  <sys-data-table
    v-model="produtosSelecionados"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-key="index"
    fixed-header
    :item-height="45"
    :height="alturaDaJanela - 292"
    show-select
    desativar_ordenacao
    :loading="loadingTable"
    @scroll-items="buscarProdutosSeTiverNoFinalDaRolagem($event)"
    @click:th="() => abrir_dialog_ordenacao_count++"
  >
    <template #top>
      <v-toolbar flat color="white" height="50px">
        <span class="subtitle-1 font-weight-medium ml-n1">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          Lista de Produtos
        </span>

        <Ordenacao
          id_unico_preferencia="ORDENACAO_TABELA_DRP_LISTA_COBERTURA_PRODUTOS"
          :itens="colunas_ordenacao"
          :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"
          @update:ordenacao="() => buscarProdutos"
          @campos:ordenacao="atualizarCamposOrdenados"
        />

        <v-divider class="mx-4" inset vertical />

        <parametrizacao-produtos-dialog
          v-show="produtosSelecionados.length"
          :produtos-para-parametrizacao="produtosSelecionados"
          @atualizado-com-sucesso="buscarProdutos"
        />

        <v-spacer />

        <v-text-field
          id="txt-pesquisa-data-table"
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          placeholder="Pesquisa"
          single-line
          hide-details
          clearable
          v-lazy-input:debounce="500"
          style="max-width: 450px"
          @change="resetarCarregamentoProdutos()"
          @keypress.enter="resetarCarregamentoProdutos()"
        />

        <ImportacaoEmMassa
          class="ml-4 mr-n3"
          :dados_importacao="dados_importacao"
          @arquivo-importacao="importarLista($event)"
        />
      </v-toolbar>
    </template>

    <template v-for="(item, key) in campos_em_ordenacao" #[`header.${item.campo}.icon_order`]>
      <span :key="key">
        <v-icon v-if="item.ordem === 'DECRESCENTE'" small v-text="'mdi-arrow-down'" />
        <v-icon v-else small v-text="'mdi-arrow-up'" />
      </span>
    </template>

    <template #item.idproduto="{item}">
     <div class="d-flex align-center">
        <span>{{ item.idproduto }}</span>
        <v-spacer />
        <DetalhesProdutoDrp :idgrupo="filtros.grupo" :filial_origem="item.filial" :idproduto="item.idproduto" />
      </div>
    </template>

    <template #item.cobertura_estoque="{ item }">
      <div class="d-flex align-center w-max-120">
        <input-formatador-de-valor
          v-model="item.cobertura_estoque"
          :max-digitos="4"
          centralizar
          :class="{
            'input-regular': true,
            'border-b-red': Number(item.cobertura_estoque) < 0,
          }"
          @focus="ev => ev.target.select()"
          @input="item.desabilitado_botao_salvar = false"
          @keyup.enter="() => salvar(item)"
        ></input-formatador-de-valor>

        <span-erro-input :erros="[]" />
      </div>
    </template>

    <template #item.estoque_min="{ item }">
      <div class="d-flex align-center w-max-120">
        <input-formatador-de-valor
          v-model="item.estoque_min"
          :max-digitos="4"
          centralizar
          :class="{
            'input-regular': true,
            'border-b-red': Number(item.estoque_min) < 0,
          }"
          @focus="ev => ev.target.select()"
          @input="item.desabilitado_botao_salvar = false"
          @keyup.enter="() => salvar(item)"
        />

        <span-erro-input :erros="[]" />
      </div>
    </template>

    <template #item.estoque_max="{ item }">
      <div class="d-flex align-center w-max-120">
        <input-formatador-de-valor
          v-model="item.estoque_max"
          :max-digitos="4"
          centralizar
          :class="{
            'input-regular': true,
            'border-b-red': Number(item.estoque_max) < 0,
          }"
          @focus="ev => ev.target.select()"
          @input="item.desabilitado_botao_salvar = false"
          @keyup.enter="() => salvar(item)"
        />

        <span-erro-input :erros="[]" />
      </div>
    </template>

    <template #item.multiplo_dist="{ item }">
      <div class="d-flex align-center w-max-120">
        <input-formatador-de-valor
          v-model="item.multiplo_dist"
          :max-digitos="4"
          centralizar
          :class="{
            'input-regular': true,
            'border-b-red': Number(item.multiplo_dist) < 0,
          }"
          @focus="ev => ev.target.select()"
          @input="item.desabilitado_botao_salvar = false"
          @keyup.enter="() => salvar(item)"
        />

        <span-erro-input :erros="[]" />
      </div>
    </template>

    <template #item.updated_at="{ item }">
      {{ item.updated_at ? item.updated_at : '-' }}
    </template>

    <template #item.acoes="{ item }">
      <v-btn
        color="primary"
        small
        text
        :disabled="item.desabilitado_botao_salvar || !salvamentoEstaValido(item)"
        @click="() => salvar(item)"
      >
        salvar
      </v-btn>
    </template>
  </sys-data-table>
</template>

<script>
import produtoAPI from "../../../api/produto"
import ParametrizacaoProdutosDialog from "./ParametrizacaoMultiplosProdutosDialog"
import SpanErroInput from "@/components/drp/coberturaPorProduto/SpanExibeErroInput.vue";
import InputFormatadorDeValor from "@/components/utils/InputFormatadorDeValor.vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import ImportacaoEmMassa from "@/components/utils/ImportacaoEmMassa/Index.vue";
import Ordenacao from "@/components/utils/dataTable/Ordenacao.vue";
import DetalhesProdutoDrp from "@/components/drp/separacaoDeMercadorias/DetalhesProduto/Index";

export default {
  name: "TabelaProdutos",
  mixins: [ResponsiveHeight],
  components: {
    InputFormatadorDeValor, SpanErroInput,
    ParametrizacaoProdutosDialog,
    ImportacaoEmMassa,
    Ordenacao,
    DetalhesProdutoDrp
  },
  props: {
    filtros: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    produtosSelecionados: [],
    search: '',
    headers: [
      { text: '', value: 'data-table-select' },
      { text: 'Filial', value: 'filial' },
      { text: 'Id Produto', value: 'idproduto' },
      { text: 'Descrição do Produto', value: 'descricao_produto' },
      { text: 'Curva Frequência', value: 'classificacao_popularidade' },
      { text: 'Curva Faturamento', value: 'classificacao_criticidade' },
      { text: 'Cobertura de Estoque', value: 'cobertura_estoque' },
      { text: 'Estoque Mínimo', value: 'estoque_min' },
      { text: 'Estoque Máximo Distribuição', value: 'estoque_max' },
      { text: 'Múltiplo de Distribuição', value: 'multiplo_dist' },
      { text: 'Usuário (última alteração)', value: 'usuario_ultima_alteracao_log' },
      { text: 'Origem da Alteração', value: 'origem_ultima_alteracao_log' },
      { text: 'Última atualização', value: 'updated_at' },
      { text: 'Ações', value: 'acoes' },
    ],
    desserts: [],
    start: 0,
    timeout: null,
    rowHeight: 48,
    perPage: 50,
    dados_importacao: {
      url: 'importacao/drp/cobertura-por-produto',
      informativo: {
        url_download_modelo: 'importacao/drp/download-modelo',
        linhas: [
          { texto: 'Ser do formato', texto_final_em_negrito: '.xlsx' },
          { texto: 'Possuir 6 colunas: ', texto_final_em_negrito: 'id_filial, id_produto, estoque_minimo, estoque_maximo, cobertura_estoque, multiplo_dist' },
          { texto: 'Possuir o cabeçalho.', texto_final_em_negrito: '' },
          { texto: 'Possuir todos os campos', texto_final_em_negrito: '' },
        ],
        headers_tabela_exemplo: ['id_filial', 'id_produto', 'estoque_minimo', 'estoque_maximo', 'cobertura_estoque', 'multiplo_dist'],
        body_tabela_exemplo: ['1', '2', '3', '4'],
      }
    },
    itensPorPagina: 300,
    loadingTable: false,
    timerScrollDataTable: null,
    todosItensPaginadosCarregados: false,
    timerPesquisaKeyPress: null,
    countTotal: 0,
    colunas_ordenacao: [
      { descricao: 'Filial', campo: 'filial' },
      { descricao: 'Id Produto', campo: 'idproduto' },
      { descricao: 'Descrição do Produto', campo: 'descricao_produto' },
      { descricao: 'Curva Frequência', campo: 'classificacao_popularidade' },
      { descricao: 'Curva Faturamento', campo: 'classificacao_criticidade' },
      { descricao: 'Cobertura de Estoque', campo: 'cobertura_estoque' },
      { descricao: 'Estoque Mínimo', campo: 'estoque_min' },
      { descricao: 'Estoque Máximo', campo: 'estoque_max' },
      { descricao: 'Múltiplo de Distribuição', campo: 'multiplo_dist' },
      { descricao: 'Usuário (última alteração)', campo: 'usuario_ultima_alteracao_log' },
      { descricao: 'Origem da Alteração', campo: 'origem_ultima_alteracao_log' },
      { descricao: 'Última atualização', campo: 'updated_at' }
    ],
    abrir_dialog_ordenacao_count: 0,
    campos_em_ordenacao: [],
    id_unico_preferencia: 'ORDENACAO_TABELA_DRP_LISTA_COBERTURA_PRODUTOS',
  }),
  watch: {
    filtros () {
      this.desserts = [];
      this.todosItensPaginadosCarregados = false;

      this.buscarProdutos();
    }
  },
  computed: {
    paginaItensAtual() {
      return Math.ceil(this.desserts.length / this.itensPorPagina);
    },
  },
  methods: {
    atualizarCamposOrdenados(campos) {
      this.desserts = [];
      this.campos_em_ordenacao = campos;
      this.$forceUpdate();
      this.buscarProdutos();
    },
    resetarCarregamentoProdutos() {
      this.desserts = [];
      this.todosItensPaginadosCarregados = false;
      this.getProdutosAposUmTempo();
    },
    getProdutosAposUmTempo() {
      this.loadingTable = true;
      clearTimeout(this.timerPesquisaKeyPress);
      this.timerPesquisaKeyPress = setTimeout(() => this.buscarProdutos(), 1000);
    },
    buscarProdutosSeTiverNoFinalDaRolagem({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 50) < scrollHeight || this.loadingTable) {
        return;
      }

      clearTimeout(this.timerScrollDataTable);
      this.timerScrollDataTable = setTimeout(() => this.buscarProdutos(), 1000);
    },
    buscarProdutos () {
      if (this.todosItensPaginadosCarregados) return;

      this.loadingTable = true;

      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        ...this.filtros,
        filtros: this.$store.getters["filtrosUniversalAvancado/filtros"],
        pagina: (this.paginaItensAtual + 1),
        itensPorPagina: this.itensPorPagina,
        pesquisa: this.search,
        id_unico_preferencia: this.id_unico_preferencia
      }

      produtoAPI.getProdutosParametrizacaoCobertura(headers, params)
        .then(response => {
          this.desserts = this.desserts.concat(response.data.produtos.data.map(item => ({
            ...item,
            cobertura_estoque: Number(item.cobertura_estoque),
            estoque_min: Number(item.estoque_min),
            estoque_max: Number(item.estoque_max),
            multiplo_dist: Number(item.multiplo_dist),
            desabilitado_botao_salvar: true,
          })));

          this.produtosSelecionados = [];

          this.countTotal = response.data.produtos.data.countTotal;
          this.loadingTable = false;

          if (response.data.produtos.data.length < this.itensPorPagina) {
            this.todosItensPaginadosCarregados = true;
          }
        })
        .catch(() => this.Helpers.logout())
    },
    salvamentoEstaValido(produto) {
      return Number(produto.cobertura_estoque) >= 0
          && Number(produto.estoque_min) >= 0
          && Number(produto.estoque_max) >= 0
          && Number(produto.multiplo_dist) > 0;
    },
    salvar(produto) {
      if (!this.salvamentoEstaValido(produto)) return;

      const params = {
        filial: produto.filial,
        idproduto: produto.idproduto,
        cobertura_estoque: Number(produto.cobertura_estoque),
        estoque_min: Number(produto.estoque_min),
        estoque_max: Number(produto.estoque_max),
        multiplo_dist: Number(produto.multiplo_dist)
      };

      api.post('/drp/produto', params)
        .then(() => {
          produto.desabilitado_botao_salvar = true
        })
        .catch(logout)
    }
  }
}
</script>

<style scoped>
.border-b-red {
  border-bottom: 2px solid #f65f5f;
}
</style>
